import styled from 'styled-components';

export const ContainerWidget = styled.div`
  height: 100%;

  margin-left: -${({ theme }) => theme.spacing(2.5)};
  margin-right: -${({ theme }) => theme.spacing(2.5)};
  margin-bottom: -${({ theme }) => theme.spacing(2.5)};
`;
